import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface DrawingState {
  reduxSketchData: object | null;    // Fabric.js canvas toJSON() 결과
  reduxSketchFrom: string | null;    // 'web' | 'mobile'
  reduxSketchOwner: string | null;   // 발표자 userId
  reduxIsSketchShare: boolean;       // 스케치 공유 중 여부
  reduxIsSketchOwner: boolean;       // 내가 발표자인지 여부
  reduxSketchWidthLimit: number;     // 발표자 모니터 너비 (스크롤 범위 제한)
  reduxSketchHeightLimit: number;    // 발표자 모니터 높이 (스크롤 범위 제한)
}

const initialState: DrawingState = {
  reduxSketchData: null,
  reduxSketchFrom: null,
  reduxSketchOwner: null,
  reduxIsSketchShare: false,
  reduxIsSketchOwner: false,
  reduxSketchWidthLimit: 1920,
  reduxSketchHeightLimit: 1080,
};

const drawingSlice = createSlice({
  name: 'drawing',
  initialState,
  reducers: {
    setSketchData(state, action: PayloadAction<object | null>) {
      state.reduxSketchData = action.payload;
    },
    setSketchFrom(state, action: PayloadAction<string | null>) {
      state.reduxSketchFrom = action.payload;
    },
    setSketchOwner(state, action: PayloadAction<string | null>) {
      state.reduxSketchOwner = action.payload;
    },
    setIsSketchShare(state, action: PayloadAction<boolean>) {
      state.reduxIsSketchShare = action.payload;
    },
    setIsSketchOwner(state, action: PayloadAction<boolean>) {
      state.reduxIsSketchOwner = action.payload;
    },
    setSketchLimit(state, action: PayloadAction<{ width: number; height: number }>) {
      state.reduxSketchWidthLimit = action.payload.width;
      state.reduxSketchHeightLimit = action.payload.height;
    },
    /** 시청자 캔버스 클리어 (CLEAR_DRAWING_CANVAS 수신 시) — 스케치 모드는 유지하면서 데이터만 제거 */
    clearSketchData(state) {
      state.reduxSketchData = null;
    },
    reset() {
      return initialState;
    },
  },
});

export const drawingActions = drawingSlice.actions;
export default drawingSlice.reducer;
